import { createAction, props } from '@ngrx/store';

import { UserProfileState } from '../models/user-profile.state';

export const setUserProfile = createAction(
  '[User Profile] Set User Profile',
  props<{ profile: UserProfileState }>(),
);
